export default {
  // Basic Information
  基本信息: "Thông tin cơ bản",
  商单名称: "Tên chiến dịch",
  请输入商单名称: "Vui lòng nhập tên đơn hàng",
  最多可输入50个字符: "Tối đa 50 ký tự",
  请输入: "Vui lòng nhập",
  商单总预算: "Tổng ngân sách chiến dịch",
  支付给达人的目标预算: "Ngân sách dự kiến cho Creator",
  请输入商单总预算: "Vui lòng nhập tổng ngân sách",
  仅可输入数字和小数点: "Chỉ được nhập số và dấu thập phân",
  预计报名时间: "Thời gian đăng ký dự kiến",
  请选择预计报名时间: "Vui lòng chọn thời gian đăng ký dự kiến",
  预计交付时间: "Thời gian giao hàng dự kiến",
  请选择预计交付时间: "Vui lòng chọn thời gian giao hàng dự kiến",
  提交: "Gửi",

  // Brand Introduction
  品牌介绍: "Giới thiệu thương hiệu",
  "向达人更好地了解品牌，提升接单可能性":
    "Giúp người sáng tạo hiểu rõ hơn về thương hiệu và tăng khả năng nhận đơn",
  品牌名称: "Tên thương hiệu",
  品牌Logo: "Logo thương hiệu",
  请上传文件: "Vui lòng tải lên tệp",
  "支持扩展名：.jpg .png…": "Hỗ trợ định dạng: .jpg .png…",
  请输入备注: "Vui lòng nhập ghi chú",

  // Creator Requirements
  达人要求: "Yêu cầu cho creator",
  满足设置要求的达人才可参加商单并申样:
    "Chỉ người sáng tạo đáp ứng yêu cầu mới có thể tham gia và yêu cầu mẫu",
  粉丝量级: "Cấp độ người theo dõi",
  "粉丝量≥": "Người theo dõi ≥",
  仅支持输入整数: "Chỉ được nhập số nguyên",
  请输入粉丝量: "Vui lòng nhập số lượng người theo dõi",
  目标达人数: "Số lượng người sáng tạo mục tiêu",
  请输入目标达人数: "Vui lòng nhập số lượng người sáng tạo mục tiêu",
  "商单预算/人": "Ngân sách/người sáng tạo",
  请输入商单预算: "Vui lòng nhập ngân sách đơn hàng",

  // Product Information
  商单商品: "Sản phẩm đơn hàng",
  商品信息: "Thông tin sản phẩm",
  修改商品: "Sửa sản phẩm",
  添加商品: "Thêm sản phẩm",
  "达人佣金%": "Hoa hồng người sáng tạo %",
  "Youpik佣金%": "Hoa hồng Youpik %",
  商品ID: "ID sản phẩm",
  所属店铺: "Cửa hàng",
  店铺短码: "Mã cửa hàng",
  库存: "Tồn kho",
  佣金: "Hoa hồng",
  商品内容不能为空: "Nội dung sản phẩm không được để trống",

  // Script and Video
  脚本范例: "Mẫu kịch bản",
  请选择脚本范例: "Vui lòng chọn mẫu kịch bản",
  请输入文案链接: "Vui lòng nhập liên kết nội dung",
  请输入有效链接: "Vui lòng nhập liên kết hợp lệ",
  添加脚本范例: "Thêm mẫu kịch bản",
  参考视频: "Video tham khảo",
  参考视频类型: "Loại video tham khảo",
  请选择视频类型: "Vui lòng chọn loại video",
  本地视频: "Video cục bộ",
  TikTok视频链接: "Liên kết video TikTok",
  请输入视频链接: "Vui lòng nhập liên kết video",
  "请输入 TikTok 视频链接": "Vui lòng nhập liên kết video TikTok",
  添加参考视频: "Thêm video tham khảo",

  // Commercial Order List
  video: "Video",
  Live: "Phát trực tiếp",
  LiveAndVideo: "Phát trực tiếp và Video",
  进行中: "Đang tiến hànhh",
  已交付: "Đã giao",
  已取消: "Đã hủy",
  复制商单: "Sao chép chiến dịch",
  编辑商单: "Chỉnh sửa chiến dịch",
  交付商单: "Giao chiến dịch",
  取消商单: "Hủy chiến dịch",
  商单编号: "Mã chiến dịch",
  当前预估支出: "Chi tiêu ước tính hiện tại",
  实际支出: "Chi tiêu thực tế",
  粉丝数k: "Người theo dõi ≥{num}",
  接单达人数: "Số creator đã nhận",
  交付视频数: "Số video đã giao",
  商单PM: "Quản lý chiến dịch",
  创建时间: "Thời gian tạo",
  交付时间: "Thời gian giao",
  交付人: "Người giao",
  分享商单: "Chia sẻ đơn hàng",
  进入工作台: "Vào bàn làm việc",
  新增商单: "Thêm đơn hàng",
  查看进度: "Xem tiến độ",
  工作台: "Không gian làm việc",
  查看详情: "Xem chi tiết",
  总预算: "Tổng ngân sách",
  交付要求: "Yêu cầu giao hàng",
  交付内容: "Nội dung giao hàng",
  TAP挂链: "Liên kết TAP",
  视频: "Video",
  必须: "Bắt buộc",
  非必须: "Không bắt buộc",
  "Ads Code": "Mã quảng cáo",
  内容数量: "Số lượng nội dung",
  内容时长: "Thời lượng nội dung",
  秒: "Giây",
  Hashtag: "Hashtag",
  添加: "Thêm",
  添加商单商品: "Thêm sản phẩm đơn hàng",
  商品: "Sản phẩm",
  商品名称: "Tên sản phẩm",
  商品价格: "Giá sản phẩm",
  人: "Người",
  份: "Phần",
  活动ID: "ID chiến dịch",
  商家短码: "Mã ngắn thương gia",
  商家名称: "Tên thương gia",
  活动: "Chiến dịch",
  可用: "Có sẵn",
  不可用: "Không khả dụng",
  状态: "Trạng thái",
  商家: "Thương gia",
  目标接单达人: "Người nhận đơn mục tiêu",
  邀约达人时间: "Thời gian mời",
  "平均预算/达人": "Ngân sách trung bình/người",
  目标总预算: "Tổng ngân sách mục tiêu",
  目标交付时间: "Thời gian giao hàng mục tiêu",
  预算把控: "Kiểm soát ngân sách",
  目标预算: "Ngân sách mục tiêu",
  "该商单开始时PM设置的总达人预算。":
    "Ngân sách tổng cho influencer được PM thiết lập khi bắt đầu.",
  预计支出: "Chi phí dự kiến",
  "已接单达人的最终报价之和。": "Tổng báo giá cuối cùng từ người nhận đơn.",
  "商单完结后,已接单达人的最终报价之和,未完结前计为0。":
    "Sau khi đơn hàng kết thúc là tổng giá, nếu chưa kết thúc thì tính là 0.",
  达人进度: "Tiến độ influencer",
  邀约达人数: "Số người được mời",
  申样达人数: "Số người yêu cầu mẫu",
  交付达人数: "Số người đã giao hàng",
  已打款达人数: "Số người đã thanh toán",
  内容进度: "Tiến độ nội dung",
  目标内容数: "Số lượng nội dung mục tiêu",
  内容交付: "Nội dung đã giao",
  合格内容: "Nội dung đạt yêu cầu",
  不合格内容: "Nội dung không đạt",
  交付效果: "Hiệu quả giao hàng",
  总播放量: "Tổng lượt xem",
  总点赞数: "Tổng lượt thích",
  总评论数: "Tổng bình luận",
  总销售件数: "Tổng sản phẩm bán được",
  商单交付提醒: "Nhắc nhở giao đơn hàng",
  "交付后达人无法进行邀请、接单、申样、履约等操作":
    "Sau khi giao, influencer sẽ không thể mời, nhận đơn, xin mẫu hay thực hiện đơn hàng",
  "，你还要继续吗？": ", bạn có muốn tiếp tục không?",
  商单取消提醒: "Nhắc nhở hủy đơn hàng",
  "取消后达人无法进行邀请、接单、申样、履约等操作":
    "Sau khi hủy, influencer sẽ không thể mời, nhận đơn, xin mẫu hay thực hiện",
  取消时间: "Thời gian hủy",
  操作人: "Người thực hiện",
  全部PIC: "Tất cả người phụ trách",
  "最多只能上传 {maxLength} 个文件": "Chỉ có thể tải lên tối đa {maxLength} tệp",
  确认提交: "Xác nhận gửi",
  修改后达人邀请信息将同步修改: "Thông tin mời influencer sẽ được cập nhật sau khi chỉnh sửa",
  仅支持输入数字和小数点: "Chỉ hỗ trợ nhập số và dấu thập phân",
  "达人发布内容后，将以该要求做为检测合格的标准":
    "Sau khi người ảnh hưởng đăng nội dung, yêu cầu này sẽ được dùng làm tiêu chuẩn đánh giá.",
  链接无效: "Liên kết không hợp lệ",
  视频链接重复: "Liên kết video bị trùng",
  adsCode码重复: "Mã Ads Code bị trùng",
  合格: "Đạt yêu cầu",
  不合格: "Không đạt yêu cầu",
  前往商家工作台: "Vào bảng điều khiển campaign",
  履约内容: "Nội dung thực hiện",
  未在规定时间内发布合格内容: "Không đăng nội dung đạt yêu cầu trong thời gian quy định",
  商单履约内容不合格: "Nội dung thực hiện chiến dịch không đạt yêu cầu",
  待审核: "Chờ duyệt",
  Hashtag错误: "Lỗi Hashtag",
  "TAP link未挂链": "Liên kết TAP chưa được gắn",
  视频时长未达标: "Thời lượng video không đạt chuẩn",
  "Ads Code未填或填写错误": "Mã Ads Code chưa điền hoặc sai",
  商单履约失败: "Thất bại trong việc thực hiện chiến dịch",
  请输入有效的URL链接: "Vui lòng nhập liên kết URL hợp lệ",
  "请输入 Ads code": "Vui lòng nhập mã quảng cáo",
  "仅可输入数字和小数点，最多两位小数":
    "Chỉ được nhập số và dấu chấm thập phân, tối đa hai chữ số thập phân",
  确认创建: "Xác nhận tạo",
  视频不大于50M: "Video không được lớn hơn 50MB",
  图片不大于5M: "Hình ảnh không được lớn hơn 5MB",
  内容: "Nội dung",
  查看数据: "Xem dữ liệu",
  最多添加10个标签: "Tối đa có thể thêm 10 thẻ",
  仅可输入整数: "Chỉ được nhập số nguyên",
  总订单数: "Tổng số đơn hàng",
  返回: "Quay lại",
  单: "Đơn",
  "符合以上粉丝量级的接受商单目标达人人数。":
    "Số lượng creator mục tiêu chấp nhận đơn hàng với mức người theo dõi như trên.",
  "和达人谈单时不可超过该预算。": "Không được vượt quá ngân sách này khi đàm phán với creator.",
  确认取消保存: "Xác nhận hủy lưu",
  取消后编辑的内容将不会保存: "Nội dung chỉnh sửa sẽ không được lưu. Tiếp tục?"
};
